import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  IStateDashboardSearchFields,
  IStateDashboardSearchRequest,
} from '@core/interfaces/istate-dashboard';
import { StateService } from '@core/services/state.service';
import { take } from 'rxjs';

@Component({
    selector: 'drdp-search-disabilities',
    templateUrl: './search-disabilities.component.html',
    styleUrls: ['./search-disabilities.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchDisabilitiesComponent {
  private stateService = inject(StateService);

  displayDropdowns: IStateDashboardSearchFields = {
    ageGroup: false,
    enrollmentProgram: false,
    homeLanguage: false,
    schoolYear: true,
    globalRatingPeriods: false,
    disability: true,
  };
  requiredFields: IStateDashboardSearchFields = {
    ageGroup: false,
    enrollmentProgram: false,
    homeLanguage: false,
    globalRatingPeriods: false,
    disability: true,
  };

  handleSearch(searchValue: IStateDashboardSearchRequest): void {
    this.stateService
      .searchDisability(searchValue)
      .pipe(take(1))
      .subscribe((res) => {
        const fileName = 'Disability.xlsx';
        const blob = new Blob([res.body], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
      });
  }
}
